import appStore from 'store';
import api from './api';
import { PAGINATION } from 'common/config';

const store = {
  namespaced: true,
  state: {
    batchList: [],
    coinList: [],
    pagination: PAGINATION,
    total: 0,
    batchDetail: {},
    detailDialogVisible: false
  },
  getters: {
    coinList: state => {
      return state.coinList.map(item => ({
        label: `${item.coinType}(${item.coinName})`,
        value: item.coinType,
        logo: item.logo
      }));
    },
    batchDetail: state => {
      return {
        ...state.batchDetail,
        coinType: (state.batchDetail.coinType || '').split(',')
      };
    }
  },
  mutations: {
    setBatchList(state, payload) {
      state.total = payload.totalCount;
      state.batchList = payload.list.slice();
    },
    setAllCoin(state, payload) {
      state.coinList = payload;
    },
    setBatchDetail(state, payload) {
      state.batchDetail = payload;
    },
    setDetailDialogVisible(state, payload) {
      state.detailDialogVisible = payload;
    }
  },
  actions: {
    list({ commit }, query) {
      api.getBatchList(query).then(({ data }) => {
        commit('setBatchList', data);
      });
    },
    listAllCoin({ commit }) {
      api.getAllCoin().then(({ data }) => {
        commit('setAllCoin', data);
      });
    },
    createBatch(context, data) {
      return api.createBatch(data);
    },
    enableBatch(context, data) {
      return api.enableBatch(data);
    },
    disableBatch(context, data) {
      return api.disableBatch(data);
    },
    updateBatch(context, data) {
      return api.updateBatch(data);
    },
    removeBatch(context, id) {
      return api.removeBatch(id);
    }
  }
};

appStore.registerModule('voteBatchSetting', store);
